<template>
	<div class="user flex main other_main">
		<asiden :asideData="asideList"></asiden>
		<div class="main_r">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import asiden from "../layout/aside/aside.vue";
export default {
	components: { asiden },
	name: "",
	data() {
		return {
			asideList: [
				{
					title: "资讯列表",
					icon: "",
					router: "/message/messagelist",
					permissions: 301,
				},
				{
					title: "新增资讯",
					icon: "",
					router: "/message/addmessage_new",
					permissions: 302,
				},
				{
					title: "快讯模版",
					icon: "",
					router: "/message/flashpc",
					permissions: 303,
				},
				{
					title: "审核管理",
					router: "/message/messageexamine",
					permissions: 311,
				},
				{
					title: "类别管理",
					icon: "",
					router: "/message/category",
					permissions: 305,
				},
				{
					title: "专区管理",
					icon: "",
					router: "/message/special",
					permissions: 306,
				},
				{
					title: "专题管理",
					icon: "",
					router: "/message/label",
					permissions: 307,
				},
				{
					title: "工具管理",
					icon: "",
					router: "/message/tools",
					permissions: 308,
				},
				{
					title: "恢复数据",
					icon: "",
					router: "/message/dellist",
					permissions: 304,
				},
				{
					title: "测试数据",
					icon: "",
					router: "/message/thirdmessage",
					permissions: 301,
				},
				{
					title: "新增资讯[旧]",
					icon: "",
					router: "/message/addmessage",
					permissions: 302,
				},
				{
					title: "AI专题",
					icon: "",
					router: "/message/aitopic",
					permissions: 311,
				},
			],
		};
	},
	mounted() {
		const role_permissions = this.$store.state.user.user.role_permissions; // 假设格式是 "100,200,300"
		if (role_permissions) {
			const permissionArray = role_permissions.split(",").map(Number); // 转换为数字数组
			this.asideList = this.asideList.filter((item) =>
				permissionArray.includes(item.permissions),
			);
		}
	},
};
</script>

<style scoped></style>
